import { styled } from '@mui/material/styles';
import SearchIcon from '@mui/icons-material/Search';

export const Styles = {
  Input: styled('input')(({ theme }) => ({
    width: '100%',
    maxWidth: '200px',
    padding: '0.5rem',
    fontSize: '0.875rem',
    border: '1px solid #ccc',
    borderRadius: '4px',
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%'
    }
  })),

  RadioBox: styled('div')({
    display: 'flex'
  }),

  BotaoContainer: styled('div')({
    display: 'flex',
    gap: '5px',
    width: '200px',
    border: '0.5px solid #5D5F64',
    borderRadius: '2px',
    alignItems: 'center',
    boxSizing: 'border-box',
    justifyContent: 'space-around'
  }),

  Icon: styled(SearchIcon)({
    fontSize: '22px',
    color: 'white'
  }),

  IconButton: styled('label')(({ theme }) => ({
    display: 'flex',
    gap: '10px',
    marginTop: '15px',
    marginRight: '10px',
    [theme.breakpoints.down('lg')]: {
      marginTop: '-10px'
    }
  })),

  Botao: styled('button')({
    width: '30px',
    borderRadius: '5px',
    height: '19px',
    backgroundColor: 'white',
    color: '#5D5F64',
    fontSize: '10px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: 'none',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
    '&:hover': {
      backgroundColor: '#2fb674',
      color: 'white'
    }
  }),

  FiltroContainer: styled('div')(({ theme }) => ({
    flex: 1,
    width: '100%',
    maxWidth: '1200px',
    [theme.breakpoints.down('md')]: {
      padding: '0 1rem',
      width: '80%',
      maxWidth: '80%',
      wrap: 'nowrap',
      height: '100%'
    }
  })),

  HeaderFilter: styled('div')({
    backgroundColor: '#363636',
    color: 'white',
    height: '50px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '-15px',
    borderRadius: '2px 2px 0px 0px'
  }),

  HeaderContent: styled('div')({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    marginRight: '150px',
    marginBottom: '-15px',
    borderRadius: '2px 2px 0px 0px'
  }),

  Titulo: styled('h1')(({ theme }) => ({
    fontSize: '16px',
    fontWeight: '400',
    paddingBottom: '8px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
      textAlign: 'center'
    }
  })),

  Filtros: styled('form')<{ isVertical?: boolean }>(
    ({ isVertical, theme }) => ({
      display: 'flex',
      marginTop: '2px',
      flexDirection: 'column',
      gap: '2px',
      backgroundColor: 'white',
      padding: '10px 35px',
      flexWrap: 'nowrap',
      //border: '1px solid #04682e',
      borderRadius: '2px',
      width: '100%',
      maxWidth: '100%',
      [theme.breakpoints.down('lg')]: {
        flexDirection: 'column',
        height: 'auto !important',
        padding: '1rem'
      }
    })
  ),

  Button: styled('button')(({ theme }) => ({
    padding: '0.75rem 1.5rem',
    backgroundColor: '#125dae',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '1rem',
    transition: 'background-color 0.3s ease',
    margin: '1rem auto 0',
    '&:hover': {
      backgroundColor: '#0e4b8a'
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
      padding: '1rem'
    }
  })),

  CampoFiltro: styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '0.5 rem',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    width: '100%',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '0.25rem'
    }
  })),

  Label: styled('label')(({ theme }) => ({
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    color: '#757575',
    minWidth: '80px',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      marginBottom: '0.25rem'
    }
  })),

  Select: styled('select')(({ theme }) => ({
    fontSize: '14px',
    width: '100%',
    maxWidth: '200px',
    marginBottom: '5px',
    height: '23px',
    borderRadius: '5px',
    [theme.breakpoints.down('md')]: {
      maxWidth: '60% !important',
      width: '60% !important'
    }
  })),

  Option: styled('option')({}),

  OpcaoRadio: styled('div')<{ isVertical?: boolean }>(
    ({ isVertical, theme }) => ({
      display: 'flex',
      flexGrow: 1,
      marginRight: 12,
      alignItems: 'flex-start',
      justifyContent: 'flex-end',
      ...(isVertical ? { flexDirection: 'row' } : { flexDirection: 'column' }),
      [theme.breakpoints.down('lg')]: {
        flexDirection: 'column !important',
        margin: '0 auto',
        gap: '10px',
        width: '80%'
      }
    })
  ),

  RadioInput: styled('input')({
    marginRight: '10px'
  }),

  RadioLabel: styled('label')({
    fontSize: '14px',
    marginRight: '20px'
  }),

  BoxTitle: styled('div')(({ theme }) => ({
    marginRight: '240px',
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'row',
    [theme.breakpoints.down('lg')]: {
      margin: '0 auto',
      flexDirection: 'row',
      alignItems: 'center',
      paddingLeft: '15px',
      width: '100%'
    }
  })),

  ImageContainer: styled('div')({
    position: 'relative',
    width: '100%',
    height: '250px',
    overflow: 'hidden'
  }),

  PropertyInfo: styled('div')({
    position: 'absolute',
    top: '10px',
    right: '10px',
    backgroundColor: '0, 0, 0, 0.6',
    padding: '8px',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  }),

  RowActions: styled('div')<{ isCampoFiltro: boolean }>(
    ({ isCampoFiltro }) => `
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 8px;
    align-items: ${isCampoFiltro ? 'normal' : 'flex-end'};
    margin-right: ${isCampoFiltro ? '1.75em' : 'unset'};
    margin-left: ${isCampoFiltro ? '0.5em' : 'unset'};
    gap: ${isCampoFiltro ? '3em' : 'unset'};
  `
  )
};
